module.exports = __webpack_public_path__ + "img/service_process@2x.1d5d7e8e.png";